import React from "react";
import Chart from "react-apexcharts";

const QueriesBySiteChart = () => {
  const data = [
    {
      site: "Site 02",
      total: 302,
      open: 38,
      overdue: 52,
    },
    {
      site: "Site 03",
      total: 138,
      open: 15,
      overdue: 22,
    },
    {
      site: "Site 01",
      total: 140,
      open: 16,
      overdue: 18,
    },
    {
      site: "Site 06",
      total: 94,
      open: 12,
      overdue: 17,
    },
    {
      site: "Site 04",
      total: 89,
      open: 11,
      overdue: 15,
    },
    {
      site: "Site 05",
      total: 61,
      open: 13,
      overdue: 14,
    },
    {
      site: "Site 07",
      total: 67,
      open: 9,
      overdue: 3,
    },
  ];
  const options = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
    },

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        borderRadius: 4,
      },
    },

    colors: [
      "#cbd5e1", // Total queries
      "#2563eb", // Open queries
      "#dc2626", // Overdue
    ],

    dataLabels: {
      enabled: false,
    },

    stroke: {
      show: false,
    },

    xaxis: {
      categories: data.map((item) => item.site),
    },

    yaxis: {
      min: 0,
      max: 350,
      tickAmount: 7,
    },

    legend: {
      position: "top",
      horizontalAlign: "center",
    },

    grid: {
      borderColor: "#e2e8f0",
    },

    tooltip: {
      shared: true,
      intersect: false,
    },
  };

  const series = [
    {
      name: "Total queries",
      data: data.map((item) => item.total),
    },
    {
      name: "Open queries",
      data: data.map((item) => item.open),
    },
    {
      name: "Overdue",
      data: data.map((item) => item.overdue),
    },
  ];

  return (
    <>
      <div className="p-3">
        <Chart options={options} series={series} type="bar" height={230} />
      </div>
    </>
  );
};

export default QueriesBySiteChart;
